// Income  Getters

export const getIncomeList = state => {
  return state.incomeList
}

export const getIncomeInfo = state => {
  return state.incomeInfo
}
